export enum QuestionTypes {
  QOptions = 'QOptions',
  QOptionsMultiple = 'QOptionsMultiple',
  QCover = 'QCover',
  QComment = 'QComment',
  QSectionBreak = 'QSectionBreak',
  QContentSection = 'QContentSection',
  QNumeric = 'QNumeric',
  QLegalAgreement = 'QLegalAgreement',
  QNPS = 'QNPS',
  QCSAT = 'QCSAT',
  QButtons = 'QButtons',
  QMatrix = 'QMatrix',
  QMatrixNumeric = 'QMatrixNumeric',
  QSlider = 'QSlider',
  QTAQTSatisfaction = 'QTAQTSatisfaction',
  QNFC = 'QNFC',
  QActions = 'QActions',
  
  ///Old Questions
  QFacesOld = 'QFaces_OLD',
  QSmileys = 'QSmileys'
}
